const getItem = () => {
  const key = 'sessionId';
  const result = new RegExp(key + "=([^;]+)").exec(document.cookie)
  return result ? result[1] : null
}

const removeItem = () => {
  document.cookie = `sessionId= ; domain=.syounggroup.com; max-age=0`
}

export {
  getItem,
  removeItem,
}